<template>
    <performance-common-dialog
        :title="'到车登记确认页面'"
        ref="performanceCommonDialog"
        @close="dialogClose"
        :width="'1300px'"
    >
        <template #top>
            <el-form
                class="form-container"
                ref="formRef"
                label-position="right"
                :model="config.form"
                label-width="100px"
            >
                <el-row>
                    <el-col :span="8">
                        <el-form-item label="发车单：" prop="componentsData">
                            <span>{{ dispatchNo }}</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="站点地址：" prop="siteAddress">
                            <span class="show-tip"
                                ><el-tooltip
                                    class="item"
                                    effect="dark"
                                    :content="arrivalInfo.siteAddress"
                                    placement="top"
                                >
                                    <el-button>
                                        {{ arrivalInfo.siteAddress }}</el-button
                                    >
                                </el-tooltip></span
                            >
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="仓库名称：" prop="whName">
                            <span>{{ arrivalInfo.whName }}</span>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <div class="table-btn">
                        <el-button
                            type="primary"
                            @click="handleArrival(false)"
                            :loading="loading"
                        >
                            到车确认
                        </el-button>
                    </div>
                </el-row>
            </el-form>
            <!-- 电子围栏校验提示和备注 -->
            <dispatch-handle-reason
                v-if="isShowHandleReasonDialog"
                ref="dispatchHandleReason"
                :isShowHandleReasonDialog.sync="isShowHandleReasonDialog"
                :componentsData="componentsData"
                :needTooltipData="needTooltipData"
                :handleType="handleType"
                :dispatchNo="dispatchNo"
                @handleSuccess="handleArrival"
                @closeFenceDialog="dialogClose"
            ></dispatch-handle-reason>
            <!-- 电子围栏校验提示和备注 -->
        </template>
        <template #table-list>
            <dispatch-arrival-check-table
                :infoId="arrivalInfo.id"
                :dictData="dictData"
                @fileList="getFileList"
            ></dispatch-arrival-check-table>
        </template>
    </performance-common-dialog>
</template>
<script>
import config from './config.js';
import PerformanceCommonDialog from '@/modules/transport/otp/components/PerformanceCommonDialog';
import DispatchArrivalCheckTable from './DispatchArrivalCheckTable';
import DispatchHandleReason from '../dispatchHandleReason/Index';
import {
    updatearrive, checkSiteAddressLclOperate
}
    from '@/modules/transport/otp/api/performanceDispatchMgmtNew.js';

export default {
    name: 'dispatchArrivalCheckIn',
    components: { PerformanceCommonDialog, DispatchArrivalCheckTable, DispatchHandleReason },
    props: {
        arrivalInfo: {
            type: Object,
            default () {
                return {};
            }
        },
        dispatchNo: {
            type: String,
            default () {
                return '';
            }
        },
        id: {
            type: Number,
            default () {
                return null;
            }
        },
        dictData: {
            type: Object,
            default () {
                return {};
            }
        }
    },
    data () {
        return {
            config: config,
            loading: false,
            totalData: [],
            pageTotal: 0,
            currentPage: 1,
            dispatchNokey: '',
            info: {},
            fileList: [],
            isShowHandleReasonDialog: false, // 是否显示围栏校验提示
            handleType: 'arrive', // 操作类型：到车
            componentsData: null,
            needTooltipData: []
        };
    },
    methods: {
        dialogClose () {
            this.$emit('components-close');
        },
        // 获取附件信息
        getFileList (list) {
            this.fileList = list;
        },
        //  手动到车，没有附件不允许到车
        /**
         * description 手动到车前 进行电子围栏校验并增加提示 和 备注人工操作原因
         * @param {Boolean} isFenceRemarked (电子围栏校验)是否填写过人工操作原因
         */
        async handleArrival ({ isFenceRemarked = false }) {
            if (!isFenceRemarked) {
                // 校验是否需要提示和备注原因
                const isNeedTooltip = await this.validateFence();
                if (isNeedTooltip) {
                    this.isShowHandleReasonDialog = true;
                    this.componentsData = this.arrivalInfo.siteAddress;
                    return;
                }
            }
            // 继续到车操作
            const param = {
                ...this.arrivalInfo,
                dispatchNo: this.dispatchNo,
                baseDispatchId: this.id
            };
            this.loading = true;
            updatearrive(param).then(res => {
                if (res && +res.code === 0) {
                    this.$message.success(res.msg || '操作成功');
                    this.dialogClose();
                }
            }).finally(() => {
                this.loading = false;
            });
        },
        // 电子围栏校验，接口返回true则需要备注人工操作原因
        validateFence () {
            const params = {
                type: 'arrive',
                dispatchNo: this.dispatchNo,
                siteAddressList: [this.arrivalInfo.siteAddress]
            };
            return checkSiteAddressLclOperate(params).then(res => {
                if (res && +res.code === 0) {
                    if (Array.isArray(res.data) && res.data.length) {
                        this.needTooltipData = res.data;
                        return true;
                    } else {
                        return false;
                    }
                }
            }).catch(() => {
                return false;
            });
        }
    },
    mounted () {
        this.$refs.performanceCommonDialog.show();
    }

};
</script>

<style scoped lang="less">
/deep/.el-form-item {
    margin: 0;
    .el-form-item__label {
        padding: 0;
    }
}
/deep/.el-tabs__header {
    margin-bottom: 0px;
}
.table-btn {
    display: flex;
    justify-content: flex-end;
}
/deep/.el-form-item__label {
    color: #999;
}
/deep/.el-form-item__content {
    color: #333;
}
.tms-performance-dialog .main-list-info {
    margin-top: 0px;
    padding-top: 0px;
}
/deep/.el-tooltip {
    border: none;
    padding: 0;
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    cursor: text;
    &:hover {
        color: #333;
        background: none;
    }
}
</style>
